<template>
  <div id="stand">
    <div class="basic-info">
      <div class="header">
        <el-button type="primary" @click="handleClose">添加新展位</el-button>
        <el-select
          v-model="query.PlaceType"
          filterable
          reserve-keyword
          clearable
          placeholder="展位类型"
          @change="getStandList"
        >
          <el-option
            v-for="item in adsPlaceTypeDic"
            :key="item.option"
            :value="item.option"
            :label="item.option"
            style="text-align: center"
          />
        </el-select>
        <el-select
          v-model="query.Status"
          filterable
          reserve-keyword
          clearable
          placeholder="发布状态"
          @change="getStandList"
        >
          <el-option
            v-for="(item, key) in adsStatusDic"
            :key="key"
            :value="key"
            :label="item"
            style="text-align: center"
          />
        </el-select>
      </div>
      <div class="stand-list" v-if="showStandList">
        <div class="stand-box" v-for="(item, index) in standList" :key="index">
          <div class="stand-info">
            <div class="cover">
              <img :src="item.imageUrl" alt="" />
            </div>
            <div class="stand-details">
              <div class="place">
                {{ item.terminalType }} {{ item.placeType }}
                <span
                  class="status-unpublish"
                  v-if="item.statusType == '未发布'"
                  >{{ item.statusType }}</span
                >
                <span
                  class="status-published"
                  v-if="item.statusType == '已发布'"
                  >{{ item.statusType }}</span
                >
                <span
                  class="status-closee"
                  v-if="item.statusType == '已过期'"
                  >{{ item.statusType }}</span
                >
                <span
                  class="status-closee"
                  v-if="item.statusType == '已下架'"
                  >{{ item.statusType }}</span
                >
              </div>
              <div class="time">{{ item.startTime }} 至 {{ item.endTime }}</div>
              <div class="redirectUrl">跳转至{{ item.redirectUrl }}</div>
            </div>
          </div>
          <div class="operation">
            <span
              v-if="item.statusType !== '已发布'"
              @click="updateStandStatus(item)"
              >发布</span
            >
            <span v-else @click="updateStandStatus(item)">撤销</span>
            <span v-if="item.statusType !== '已发布'" @click="toDetails(item)"
              >编辑</span
            >
            <span class="delete" @click="deleteStand(item.id)">删除</span>
          </div>
        </div>
      </div>
      <div class="none-stand" v-else>
        <div class="none-box">
          <img src="@/assets/image/stand-none.png" alt="" />
          <div class="none-tip">
            当前暂无广告信息，单击下面“立即添加”按钮添加广告基本信息。
          </div>
          <el-button type="primary" @click="handleClose">立即添加</el-button>
        </div>
      </div>
    </div>
    <el-dialog
      :title="tit + '展位'"
      :visible.sync="isStandShow"
      width="550px"
      :before-close="handleClose"
      custom-class="stand-dialog"
    >
      <el-form
        label-position="left"
        label-width="5rem"
        ref="adsStand"
        :rules="rules"
        :model="adsStand"
      >
        <el-form-item label="展位图片" class="auto-height">
          <div class="basic-head">
            <div class="basic-head-item">
              <img
                src="@/assets/image/default-img.png"
                alt="default"
                class="default-img"
                v-if="!photoUrl"
              />
              <div class="img" v-else>
                <img :src="photoUrl" alt="headImg" class="basic-head-img" />
              </div>
              <el-upload
                action="https://jsonplaceholder.typicode.com/posts/"
                :on-change="uploadChange"
                list-type="picture"
                :show-file-list="false"
                :http-request="getFile"
              >
                <el-button class="upload-btn">{{ uploadText }}</el-button>
              </el-upload>
            </div>
            <div class="form-tip">
              注意：建议上传格式为jpg/jpeg/png且大小不超过5MB的图片
            </div>
          </div>
        </el-form-item>
        <el-form-item label="选择终端" prop="terminalType">
          <el-select
            v-model="adsStand.terminalType"
            filterable
            reserve-keyword
            clearable
            placeholder="请选择终端类型"
          >
            <el-option
              v-for="item in adsTerminalTypeDic"
              :key="item.option"
              :value="item.option"
              :label="item.option"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="投放位置" prop="placeType">
          <el-select
            v-model="adsStand.placeType"
            filterable
            reserve-keyword
            clearable
            placeholder="请选择投放位置"
          >
            <el-option
              v-for="item in adsPlaceTypeDic"
              :key="item.option"
              :value="item.option"
              :label="item.option"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="投放时间">
          <el-date-picker
            class="date-picker"
            v-model="launchTime"
            type="daterange"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="['00:00:00', '23:59:59']"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item label="优先级">
          <el-select
            v-model="adsStand.sort"
            filterable
            reserve-keyword
            clearable
            placeholder="请选择优先级"
          >
            <el-option
              v-for="index in 10"
              :key="index"
              :value="index"
              :label="index"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="跳转链接" class="redirectUrl">
          <el-input
            v-model="adsStand.redirectUrl"
            placeholder="请输入跳转链接"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="
            isStandShow = false;
            adsStand = {};
          "
          size="mini"
          >取消</el-button
        >
        <el-button
          type="primary"
          :loading="isLoading"
          @click="submitStand"
          size="mini"
          >确定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getStandList,
  getAdsInfo,
  updateAdsInfo,
  createStand,
  updateStandInfo,
  updateStandStatus,
  deleteStand,
} from "@/http/api/ads";
import { dateFormat } from "@/common/filters";
import { getAdsSettings, getInformationSettings } from "@/http/api/system";
export default {
  data() {
    return {
      id: this.$route.params.id,
      query: {
        Status: "",
        PlaceType: "",
      },
      submitText: "保存",
      uploadText: "上传图片",
      tit: "添加",
      standList: [],
      showStandList: true,
      isLoading: false,
      adsStand: {
        terminalType: "",
        placeType: "",
        sort: 0,
        startTime: null,
        endTime: null,
        redirectUrl: "",
      },
      launchTime: [],
      placeId: "",
      photoUrl: "",
      photoFile: {},
      isStandShow: false,
      adsPlaceTypeDic: [],
      adsTerminalTypeDic: [],
      adsStatusDic: {
        UnPublish: "未发布",
        Published: "已发布",
        UnShelved: "已下架",
        Expired: "已过期",
      },
      rules: {
        placeType: [
          { required: true, message: "请选择投放位置", trigger: "change" },
        ],
        terminalType: [
          { required: true, message: "请选择终端类型", trigger: "change" },
        ],
      },
    };
  },
  mounted() {
    this.getAdsSetting();
    this.getStandList();
  },
  methods: {
    getAdsSetting() {
      getAdsSettings().then((res) => {
        res.result.map((item) => {
          if (item.name == "Deer.Advert.Collection.PlaceType") {
            this.adsPlaceTypeDic = item.value;
          }
          if (item.name == "Deer.Advert.Collection.TerminalType") {
            this.adsTerminalTypeDic = item.value;
          }
        });
      });
    },
    handleClose() {
      this.isStandShow = !this.isStandShow;
      this.tit = "添加";
      this.photoUrl = "";
      this.adsStand = {
        terminalType: "",
        placeType: "",
        redirectUrl: "",
        sort: 0,
        startTime: null,
        endTime: null,
      };
      this.launchTime = [];
    },

    toDetails(item) {
      this.isStandShow = !this.isStandShow;
      this.tit = "管理";
      this.placeId = item.id;
      this.adsStand.terminalType = item.terminalType;
      this.adsStand.placeType = item.placeType;
      this.adsStand.sort = item.sort;
      this.adsStand.startTime = item.startTime;
      this.adsStand.endTime = item.endTime;
      this.adsStand.redirectUrl = item.redirectUrl;
      this.photoUrl = item.imageUrl;
      if (item.startTime && item.endTime) {
        this.launchTime = [item.startTime, item.endTime];
      }
    },
    submitStand() {
      if (this.launchTime.length > 0) {
        this.adsStand.startTime = dateFormat(this.launchTime[0]);
        this.adsStand.endTime = dateFormat(this.launchTime[1]);
      } else {
        this.adsStand.startTime = null;
        this.adsStand.endTime = null;
      }
      this.$refs.adsStand.validate((valid) => {
        if (valid) {
          this.isLoading = true;
          if (this.tit == "添加") {
            var formData = new FormData();
            formData.append("AdvertStand", JSON.stringify(this.adsStand));
            if (JSON.stringify(this.photoFile) != "{}") {
              formData.append("File", this.photoFile);
            }
            createStand(this.id, formData)
              .then((res) => {
                if (res && res.code == 10200) {
                  this.getStandList();
                  this.isStandShow = !this.isStandShow;
                  this.$message.success({
                    message: "添加成功",
                    showClose: true,
                  });
                }
                this.isLoading = false;
              })
              .catch((err) => {
                this.isLoading = false;
              });
          } else {
            this.isLoading = true;
            if (this.launchTime.length > 0) {
              this.adsStand.startTime = dateFormat(this.launchTime[0]);
              this.adsStand.endTime = dateFormat(this.launchTime[1]);
            } else {
              this.adsStand.startTime = null;
              this.adsStand.endTime = null;
            }
            var formData = new FormData();
            formData.append("AdvertStand", JSON.stringify(this.adsStand));
            if (JSON.stringify(this.photoFile) != "{}") {
              formData.append("File", this.photoFile);
            }
            updateStandInfo(this.id, this.placeId, formData)
              .then((res) => {
                if (res && res.code == 10200) {
                  this.getStandList();
                  this.isStandShow = !this.isStandShow;
                  this.$message.success({
                    message: "修改成功",
                    showClose: true,
                  });
                } else {
                  this.$message({
                    message: res.message,
                    showClose: true,
                  });
                }
                this.isLoading = false;
              })
              .catch((err) => {
                this.isLoading = false;
                this.$message({
                  message: err.error.message,
                  showClose: true,
                });
              });
          }
        } else {
          return false;
        }
      });
    },
    updateStandStatus(row) {
      let tit = row.statusType == "已发布" ? "撤销" : "发布";
      let statusType = row.statusType == "已发布" ? "UnShelved" : "Published";
      this.$confirm(`是否${tit}该展位？`, `${tit}展位`, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          updateStandStatus(row.id, statusType).then((res) => {
            if (res.code == 10200) {
              this.getStandList();
              this.$message.success({ message: `${tit}成功`, showClose: true });
            }
          });
        })
        .catch(() => {});
    },
    getStandList() {
      getStandList(this.id, this.query).then((res) => {
        if (res && res.result) {
          this.standList = res.result.items;
          this.showStandList = this.standList.length == 0 ? false : true;
        }
      });
    },
    // 上传图片回调
    uploadChange(file) {
      this.photoUrl = file.url;
      this.uploadText = "更换图片";
    },
    getFile(item) {
      this.photoFile = item.file;
    },
    // 删除展位
    deleteStand(id) {
      this.$confirm(`是否移除该展位？`, "移除展位", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          deleteStand(id).then((res) => {
            if (res.code == 10200) {
              this.getStandList();
              this.$message.success({ message: "移除成功", showClose: true });
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>
<style scoped lang='scss'>
@import "@/styles/mixin.scss";

#stand {
  padding: 20px;
  .basic-info {
    background-color: #fff;
    padding: 20px;
    text-align: left;
    min-width: 960px;
    box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.2);
    .header {
      padding-bottom: 20px;
      border-bottom: 1px solid #dfdfdf;
      .el-select {
        margin-left: 10px;
        width: 100px;
      }
    }
    .stand-list {
      min-height: calc(100vh - 260px);
      .stand-box {
        @include flex(row, center);
        justify-content: space-between;
        padding: 20px 54px;
        width: calc(100% - 108px);
        .stand-info {
          @include flex(row, center);
          .cover {
            @include flex(column, center);
            justify-content: center;
            margin-right: 97px;
            text-align: center;
            width: 140px;
            height: 97px;
            img {
              max-width: 140px;
              max-height: 97px;
              width: auto;
              height: auto;
            }
          }
          .stand-details {
            .place {
              margin-bottom: 20px;
              font-size: 14px;
              color: #000;
              .status-closee,
              .status-unpublish,
              .status-published {
                margin-left: 14px;
                padding: 2px 8px;
                border-radius: 2px;
                font-size: 12px;
                color: #fff;
              }
              .status-closee {
                background: #f58171;
              }
              .status-unpublish {
                background: #82abf0;
              }
              .status-published {
                background: #92d089;
              }
            }
            .time {
              margin-bottom: 20px;
              color: #2b2b2b;
              font-size: 14px;
            }
            .redirectUrl {
              font-size: 14px;
              color: #717171;
            }
          }
        }
        .operation {
          font-size: 14px;
          color: $--color-primary;
          cursor: pointer;
          span {
            margin-left: 40px;
          }
        }
        &:hover {
          background: #f3f6fc;
        }
      }
    }
    .none-stand {
      @include flex(column, center);
      justify-content: center;
      width: 100%;
      min-height: 400px;
      height: calc(100vh - 210px);
      text-align: center;
      img {
        margin-bottom: 10px;
        width: 250px;
        height: auto;
      }
      .none-tip {
        margin-bottom: 16px;
        font-size: 14px;
        color: #9d9d9d;
      }
    }
  }
  ::v-deep .stand-dialog {
    .el-dialog__body {
      padding: 30px 20px 10px;
      .redirectUrl {
        margin-bottom: 0;
      }
    }
    .basic-head {
      .basic-head-item {
        display: flex;
        align-items: flex-end;
        margin-bottom: 8px;
        line-height: 0;
        .img {
          @include flex(column, center);
          justify-content: center;
          margin-right: 10px;
          text-align: center;
          background: #dfdfdf;
          width: 143px;
          height: 148px;
          img {
            margin-right: 0;
            max-width: 143px;
            max-height: 148px;
            width: auto;
            height: auto;
          }
        }
        .default-img,
        .basic-head-img {
          margin-right: 10px;
          width: 143px;
          height: 148px;
        }

        .upload-btn {
          border: 1px solid rgba(221, 221, 221, 1);
          width: 110px;
          height: 30px;
          font-size: 12px;
          font-weight: 400;
          color: rgba(0, 0, 0, 1);
        }
      }
    }
    .el-select {
      width: 100%;
    }
  }
  ::v-deep .el-date-editor {
    width: 100% !important;
    .el-input__inner {
      padding-left: 30px;
    }
    .el-icon-date {
      left: 10px;
    }

    .el-icon-circle-close {
      position: absolute;
      right: 0;
    }
  }
}
</style>
